module.exports = __webpack_public_path__ + "img/cover.770113df.webp";